"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _icons = require("../../../icons");

var _utils = require("../../../utils");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownSelectSearchField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var query = _ref.query,
      onChange = _ref.onChange,
      setHighlightedIndex = _ref.setHighlightedIndex,
      ulRef = _ref.ulRef,
      triggerRef = _ref.triggerRef,
      ariaLabel = _ref.ariaLabel,
      placeholder = _ref.placeholder;

  var handleSearchChange = function handleSearchChange(event) {
    if (event && event.target) {
      onChange(event.target.value);
    }
  };

  var handleSearchKeyDown = function handleSearchKeyDown(event) {
    if (event.key === _utils.EventKeys.ARROW_DOWN && setHighlightedIndex && ulRef.current) {
      event.preventDefault(); // update UI by focusing and internal downshift state to consistently navigate with arrow keys

      setHighlightedIndex(0);
      ulRef.current.focus();
    } // When tabbing away from the search field


    if (event.key === _utils.EventKeys.TAB || event.key === _utils.EventKeys.ESCAPE) {
      event.preventDefault();

      if (triggerRef && triggerRef.current) {
        triggerRef.current.click();
      }
    }
  };

  return (0, _core.jsx)(_.Input, {
    ref: ref,
    width: "100%",
    value: query,
    placeholder: placeholder,
    onChange: handleSearchChange,
    insetElementLeading: {
      element: (0, _core.jsx)(_icons.IconSearch, {
        "aria-hidden": true,
        color: "primary70"
      })
    },
    "aria-label": ariaLabel,
    onKeyDown: handleSearchKeyDown
  });
});
var _default = DropdownSelectSearchField;
exports.default = _default;